import {
  REQUEST_PREOPEN_MANAGER_PENDING_CLAIMS,
  SET_PREOPEN_MANAGER_PENDING_CLAIMS,
} from 'containers/PreOpenManagerPendingClaims/constants';

export const requestPendingClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_PREOPEN_MANAGER_PENDING_CLAIMS,
  status,
  page,
  pageSize,
});

export const setPendingClaims = (response: any) => ({
  type: SET_PREOPEN_MANAGER_PENDING_CLAIMS,
  response,
});
